import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import GlobalStyle from "./styles/global"; // Mantém GlobalStyle aqui

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <>
    <GlobalStyle />
    <App />
  </>
);
